import * as React from "react";

export enum PROTECTED_PATHS {
  ACCOUNT_ONBOARDING_GET_STARTED = "/account-onboarding",
  DASHBOARD = "/dashboard",
  SETTINGS = "/settings",
  ORGANIZATION_SETTINGS = "/organization-settings",
  ACCOUNT = "/account",
  USER_INFO = "/user-info/:userId",
  FOLDER_VIEW = "/folder/:folderId/:folderName",
  FOLDER_FOR_USER_VIEW = "/folder/:userId/:folderId/:folderName",
  PROPERTIES = "/properties",
  NEW_PROPERTY = "/new-property",
  PROPERTY = "/property/:propertyId",
  PROPERTY_OWNER_REPORT = "/property/:propertyId/owner-report",
  CREATE_SINGLE_FAMILY_PROPERTY = "/property-onboarding/create-single-family-property",
  CREATE_MULTI_FAMILY_PROPERTY = "/property-onboarding/create-multi-family-property",
  UPLOAD_PHOTOS = "/property-onboarding/upload-photos",
  UPLOAD_PROPERTY_DOCUMENTS = "/property-onboarding/upload-documents",
  SIGN_DOCUMENTS = "/property-onboarding/sign-documents",
  CALENDAR_BLOCK = "/property-onboarding/calendar-block",
  FINISH_PROPERTY_ONBOARDING = "/property-onboarding/finish",
  EDIT_SINGLE_FAMILY_PROPERTY = "/edit-single-family-property/:propertyId",
  EDIT_MULTI_FAMILY_PROPERTY = "/edit-multi-family-property/:propertyId",
  INDIVIDUAL_EDIT_REQUEST = "/property/:propertyId/edit-request/:id",
  MESSAGES = "/messages",
  SUPPORT = "/support",
  TAPE_CHART = "/tape-chart",
  PERFORMANCE = "/performance",
  TASKS = "/tasks",
  REPORTS = "/reports",
  MY_REPORTS = "/my-reports",
  INDIVIDUAL_REPORT_BY_HOMEOWNER = "/individual-report/:userId",
  ORGANIZATION_INFO = "/organization-info/:id",
  USERS = "/users",
}

export const HOProtectedRoutes = [
  {
    key: "Dashboard",
    path: PROTECTED_PATHS.DASHBOARD,
    component: React.lazy(() => import("../views/dashboard/index")),
  },
  {
    key: "Account Onboarding - Get Started",
    path: PROTECTED_PATHS.ACCOUNT_ONBOARDING_GET_STARTED,
    component: React.lazy(() => import("../views/onboarding/account/index")),
  },
  {
    key: "Account",
    path: PROTECTED_PATHS.ACCOUNT,
    component: React.lazy(() => import("../views/account/index")),
  },
  {
    key: "Folder View",
    path: PROTECTED_PATHS.FOLDER_VIEW,
    component: React.lazy(() => import("../views/account/folder")),
  },
  {
    key: "Properties",
    path: PROTECTED_PATHS.PROPERTIES,
    component: React.lazy(() => import("../views/properties")),
  },
  {
    key: "Property",
    path: PROTECTED_PATHS.PROPERTY,
    component: React.lazy(
      () => import("../views/properties/individualProperty")
    ),
  },
  {
    key: "Property Owner Report",
    path: PROTECTED_PATHS.PROPERTY_OWNER_REPORT,
    component: React.lazy(() => import("../views/reports/ownerReport")),
  },
  {
    key: "Property Onboarding - Create Single Family Property",
    path: PROTECTED_PATHS.CREATE_SINGLE_FAMILY_PROPERTY,
    component: React.lazy(
      () => import("../views/onboarding/property/singleFamilyProperty")
    ),
  },
  {
    key: "Property Onboarding - Create Multi-Family Property",
    path: PROTECTED_PATHS.CREATE_MULTI_FAMILY_PROPERTY,
    component: React.lazy(
      () => import("../views/onboarding/property/multiFamilyProperty")
    ),
  },
  {
    key: "Property Onboarding - Upload Photos",
    path: PROTECTED_PATHS.UPLOAD_PHOTOS,
    component: React.lazy(
      () => import("../views/onboarding/property/uploadPhotos")
    ),
  },
  {
    key: "Property Onboarding - Finish Property Onboarding",
    path: PROTECTED_PATHS.FINISH_PROPERTY_ONBOARDING,
    component: React.lazy(
      () => import("../views/onboarding/property/finishPropertyOnboarding")
    ),
  },
  {
    key: "New Property",
    path: PROTECTED_PATHS.NEW_PROPERTY,
    component: React.lazy(() => import("../views/properties/newProperty")),
  },
  {
    key: "Property Onboarding - Upload Documents",
    path: PROTECTED_PATHS.UPLOAD_PROPERTY_DOCUMENTS,
    component: React.lazy(
      () => import("../views/onboarding/property/uploadPropertyDocuments")
    ),
  },
  {
    key: "Property Onboarding - Sign Documents",
    path: PROTECTED_PATHS.SIGN_DOCUMENTS,
    component: React.lazy(
      () => import("../views/onboarding/property/signDocuments")
    ),
  },
  {
    key: "Property Onboarding - Calendar Block",
    path: PROTECTED_PATHS.CALENDAR_BLOCK,
    component: React.lazy(
      () => import("../views/onboarding/property/calendarBlock")
    ),
  },
  {
    key: "Edit Single Family Property",
    path: PROTECTED_PATHS.EDIT_SINGLE_FAMILY_PROPERTY,
    component: React.lazy(
      () => import("../views/properties/editSingleFamilyProperty")
    ),
  },
  {
    key: "Edit Multi Family Property",
    path: PROTECTED_PATHS.EDIT_MULTI_FAMILY_PROPERTY,
    component: React.lazy(
      () => import("../views/properties/editMultiFamilyProperty")
    ),
  },
  {
    key: "Individual Edit Request",
    path: PROTECTED_PATHS.INDIVIDUAL_EDIT_REQUEST,
    component: React.lazy(
      () => import("../views/editRequests/individualEditRequest")
    ),
  },
  {
    key: "Messages",
    path: PROTECTED_PATHS.MESSAGES,
    component: React.lazy(() => import("../views/messages/index")),
  },
  {
    key: "Tape Chart",
    path: PROTECTED_PATHS.TAPE_CHART,
    component: React.lazy(() => import("../views/tapeChart/index")),
  },
  {
    key: "Performance",
    path: PROTECTED_PATHS.PERFORMANCE,
    component: React.lazy(() => import("../views/performance/index")),
  },
  {
    key: "Tasks",
    path: PROTECTED_PATHS.TASKS,
    component: React.lazy(() => import("../views/tasks/index")),
  },
  {
    key: "Individual Report By Homeowner",
    path: PROTECTED_PATHS.INDIVIDUAL_REPORT_BY_HOMEOWNER,
    component: React.lazy(() => import("../views/reports/individualReportByHomeowner")),
  },
];

export const SAProtectedRoutes = [
  {
    key: "Dashboard",
    path: PROTECTED_PATHS.DASHBOARD,
    component: React.lazy(() => import("../views/dashboard/index")),
  },
  {
    key: "Settings",
    path: PROTECTED_PATHS.SETTINGS,
    component: React.lazy(() => import("../views/settings/index")),
  },
  {
    key: "Organization Settings",
    path: PROTECTED_PATHS.ORGANIZATION_SETTINGS,
    component: React.lazy(() => import("../views/organizationSettings/index")),
  },
  {
    key: "Account Onboarding - Get Started",
    path: PROTECTED_PATHS.ACCOUNT_ONBOARDING_GET_STARTED,
    component: React.lazy(() => import("../views/onboarding/account/index")),
  },
  {
    key: "Account",
    path: PROTECTED_PATHS.ACCOUNT,
    component: React.lazy(() => import("../views/account/index")),
  },
  {
    key: "User Info",
    path: PROTECTED_PATHS.USER_INFO,
    component: React.lazy(() => import("../views/settings/viewIndividualUser")),
  },
  {
    key: "Folder View",
    path: PROTECTED_PATHS.FOLDER_VIEW,
    component: React.lazy(() => import("../views/account/folder")),
  },
  {
    key: "Folder View for User",
    path: PROTECTED_PATHS.FOLDER_FOR_USER_VIEW,
    component: React.lazy(() => import("../views/account/folder")),
  },
  {
    key: "Properties",
    path: PROTECTED_PATHS.PROPERTIES,
    component: React.lazy(() => import("../views/properties")),
  },
  {
    key: "Property",
    path: PROTECTED_PATHS.PROPERTY,
    component: React.lazy(
      () => import("../views/properties/individualProperty")
    ),
  },
  {
    key: "Property Owner Report",
    path: PROTECTED_PATHS.PROPERTY_OWNER_REPORT,
    component: React.lazy(() => import("../views/reports/ownerReport")),
  },
  {
    key: "Property Onboarding - Create Single Family Home",
    path: PROTECTED_PATHS.CREATE_SINGLE_FAMILY_PROPERTY,
    component: React.lazy(
      () => import("../views/onboarding/property/singleFamilyProperty")
    ),
  },
  {
    key: "Property Onboarding - Create Multi-Family Property",
    path: PROTECTED_PATHS.CREATE_MULTI_FAMILY_PROPERTY,
    component: React.lazy(
      () => import("../views/onboarding/property/multiFamilyProperty")
    ),
  },
  {
    key: "Property Onboarding - Finish Property Onboarding",
    path: PROTECTED_PATHS.FINISH_PROPERTY_ONBOARDING,
    component: React.lazy(
      () => import("../views/onboarding/property/finishPropertyOnboarding")
    ),
  },
  {
    key: "New Property",
    path: PROTECTED_PATHS.NEW_PROPERTY,
    component: React.lazy(() => import("../views/properties/newProperty")),
  },
  {
    key: "Property Onboarding - Upload Photos",
    path: PROTECTED_PATHS.UPLOAD_PHOTOS,
    component: React.lazy(
      () => import("../views/onboarding/property/uploadPhotos")
    ),
  },
  {
    key: "Property Onboarding - Upload Documents",
    path: PROTECTED_PATHS.UPLOAD_PROPERTY_DOCUMENTS,
    component: React.lazy(
      () => import("../views/onboarding/property/uploadPropertyDocuments")
    ),
  },
  {
    key: "Property Onboarding - Sign Documents",
    path: PROTECTED_PATHS.SIGN_DOCUMENTS,
    component: React.lazy(
      () => import("../views/onboarding/property/signDocuments")
    ),
  },
  {
    key: "Property Onboarding - Calendar Block",
    path: PROTECTED_PATHS.CALENDAR_BLOCK,
    component: React.lazy(
      () => import("../views/onboarding/property/calendarBlock")
    ),
  },
  {
    key: "Edit Single Family Property",
    path: PROTECTED_PATHS.EDIT_SINGLE_FAMILY_PROPERTY,
    component: React.lazy(
      () => import("../views/properties/editSingleFamilyProperty")
    ),
  },
  {
    key: "Edit Multi Family Property",
    path: PROTECTED_PATHS.EDIT_MULTI_FAMILY_PROPERTY,
    component: React.lazy(
      () => import("../views/properties/editMultiFamilyProperty")
    ),
  },
  {
    key: "Individual Edit Request",
    path: PROTECTED_PATHS.INDIVIDUAL_EDIT_REQUEST,
    component: React.lazy(
      () => import("../views/editRequests/individualEditRequest")
    ),
  },
  {
    key: "Messages",
    path: PROTECTED_PATHS.MESSAGES,
    component: React.lazy(() => import("../views/messages/index")),
  },
  {
    key: "Tasks",
    path: PROTECTED_PATHS.TASKS,
    component: React.lazy(() => import("../views/tasks/index")),
  },
  {
    key: "Tape Chart",
    path: PROTECTED_PATHS.TAPE_CHART,
    component: React.lazy(() => import("../views/tapeChart/index")),
  },
  {
    key: "Performance",
    path: PROTECTED_PATHS.PERFORMANCE,
    component: React.lazy(() => import("../views/performance/index")),
  },
  {
    key: "Reports",
    path: PROTECTED_PATHS.REPORTS,
    component: React.lazy(() => import("../views/reports/reports")),
  },
  {
    key: "Support",
    path: PROTECTED_PATHS.SUPPORT,
    component: React.lazy(() => import("../views/support/index")),
  },
  {
    key: "Individual Report By Homeowner",
    path: PROTECTED_PATHS.INDIVIDUAL_REPORT_BY_HOMEOWNER,
    component: React.lazy(() => import("../views/reports/individualReportByHomeowner")),
  },
];

export const MainSailAdminProtectedRoutes = [
  {
    key: "Dashboard",
    path: PROTECTED_PATHS.DASHBOARD,
    component: React.lazy(() => import("../views/dashboard/index")),
  },
  {
    key: "Organization Info",
    path: PROTECTED_PATHS.ORGANIZATION_INFO,
    component: React.lazy(() => import("../views/dashboard/organizationInfo")),
  },
  {
    key: "Users",
    path: PROTECTED_PATHS.USERS,
    component: React.lazy(() => import("../views/mainsailAdmin/users")),
  },
];
